'use strict';

/**
 * data-sw-add-to-cart
 *
 * Use to add to cart via AJAX.
 * This autohandler expects the element to have an href and wil luse that as the endpoint to submit to
 *
 */
var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var urlManager = require('url');

$(function() {
  $('body').on('click', '[data-sw-add-to-cart]', function (e) {
    var $el = $(this);
    var url = $el.attr('href');

    if(url) {
      e.preventDefault();
    } else {
      return;
    }

    $.swAjax({
      url: url,
      type: 'POST',
      error: function error(jqXHR, textStatus) {
        if(textStatus !== $.swAjax.ERROR_TYPES.TIMEOUT) {
          $.swAjax.triggerDefaultFailNotey();
        }
      },
      success: function success(data) {
        var urlObj = urlManager.parse(url, true);
        sw.trigger('cart-add-product', data, urlObj.query.spin);
      }
    });
  });
});
